var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "switch-box-component" }, [
    _c("label", { on: { click: _vm.onClick } }, [_vm._t("default")], 2),
    _c("input", {
      attrs: { type: "checkbox" },
      domProps: { checked: _vm.internalValue },
    }),
    _c(
      "div",
      {
        staticClass: "switch-box",
        class: { checked: _vm.internalValue },
        on: { click: _vm.onClick },
      },
      [_c("div", { staticClass: "switch-box-handle" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }